import {btn, column, Component, EntityID, h3, menu, store, table, tbar, Window} from "@intermesh/goui";
import {Field, Form} from "./Form";
import {DefaultFieldWindow} from "./fields/DefaultFieldWindow";
import {createFieldWindow, FieldWindowMap, FieldWindowMapType} from "./fields/FieldMap";
import {jmapds} from "@intermesh/groupoffice-core";

import {t} from "./Translate";
export class FormFieldDetail extends Component {
	private table;
	private formId?: EntityID;
	private form?: Form;
	constructor() {
		super();
		this.cls = "card";

		this.table = this.createTable();

		this.items.add(
			tbar({}, h3("Fields"), "->", btn({
				icon: "expand_less",
				handler: (btn) => {
					this.table.hidden = !this.table.hidden;

					btn.icon = this.table.hidden ? "expand_more" : "expand_less";
				}
			})),
			this.table,

			tbar({},
				'->',
				btn({
					cls: "primary filled",
					icon: "add",
					text: t("Add"),
					menu: menu({},

						...this.createFieldMenuOptions()

						)

				})
			)
		);
	}


	private createTable() {
		return table({
			// cls: "fit",
			dropBetween: true,
			draggableRows: true,
			listeners: {
				rowdblclick:({target, storeIndex}) => {
					this.edit(target.store.get(storeIndex)!);
				},
				drop: async ({target, fromIndex, toIndex}) => {
					try {
						target.store.move(fromIndex, toIndex);

						await jmapds("Form").update(this.form!.id, {
							fields: target.store.data.map(f => {
								return {id: f.id};
							})
						});
					} catch(e) {
						void Window.error(e);
					}
				}
			},
			columns:[
				column({
					resizable: true,
					id: "label",
					header: t("Label")
				}),

				column({
					width: 100,
					resizable: true,
					id: "type",
					header: t("Type"),
					renderer:columnValue => t(columnValue)
				}),

				column({
					id: "btn",
					width: 48,
					renderer:(columnValue, record, td, table1, storeIndex) => {
						return btn({
							icon: "more_vert",
							menu: menu({},

								btn({
									icon: "edit",
									text: t("Edit"),
									handler: () => {
										this.edit(record);
									}
								}),

								btn({
									icon: "delete",
									text: t("Delete"),
									handler: button => {
										this.deleteField(storeIndex);
									}
								})

								)
						});
					}
				})
			],
			store: store<Field>()
		})
	}

	private edit(field:Field) {
		const win = createFieldWindow(field.type, this.form!);
		win.form.value = field;
		win.show();
	}


	public load(form: Form) {

		this.form = form;
		this.table.store.loadData(form.fields ?? [], false);

	}

	private createFieldMenuOptions() {

		return Object.keys(FieldWindowMap).map(type => {
			return btn({
				text: t(type),
				handler: () => {
					if(this.form) {
						const win = createFieldWindow(type as keyof FieldWindowMapType,  this.form);
						win.show();
					}
				}
			})
		});


	}

	private async deleteField(storeIndex: number) {
		try {

			const confirmed = await Window.confirm(t("Are you sure you want to delete this field?"));
			if(!confirmed) {
				return false;
			}

			this.mask();
			this.form!.fields!.splice(storeIndex, 1);
			await jmapds("Form").update(this.form!.id, {
				fields: this.form!.fields!
			})
		} catch(e:any) {
			void Window.error(e.message);
		} finally {
			this.unmask();
		}
	}
}